var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "addBox"
  }, [_c('el-drawer', {
    attrs: {
      "visible": _vm.visiable,
      "direction": "rtl",
      "size": "400px",
      "before-close": _vm.close,
      "custom-class": "tvuoneDrawer",
      "show-close": _vm.showClose && !_vm.selectDevicePeerId,
      "wrapper-closable": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.visiable = $event;
      }
    }
  }, [_c('div', {
    class: {
      settingTitle: _vm.selectDevicePeerId
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.showTitle ? _c('div', {
    staticClass: "title"
  }, [!_vm.selectDevicePeerId ? _c('span', [_vm._v(_vm._s(_vm.$route.name === 'intercom' ? _vm.$t('intercom.addToIntercom') : _vm.$t('addTvuOne.addToP')))]) : _c('span', [_vm._v(_vm._s(_vm.$t(`addTvuOne.${_vm.titleMap[_vm.selectDeviceType]}`)))]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.selectDevicePeerId,
      expression: "!selectDevicePeerId"
    }],
    staticClass: "el-icon-search pointer",
    on: {
      "click": () => {
        _vm.showTitle = false, _vm.packStatus = 'all', _vm.getSourceList();
      }
    }
  })]) : !_vm.showTitle && !_vm.selectDevicePeerId ? _c('div', {
    staticClass: "searchContent"
  }, [_c('el-select', {
    staticClass: "packReceiverSelect",
    attrs: {
      "popper-class": "packReceiverSelect"
    },
    on: {
      "change": _vm.changeSelectType
    },
    model: {
      value: _vm.selectDeviceType,
      callback: function ($$v) {
        _vm.selectDeviceType = $$v;
      },
      expression: "selectDeviceType"
    }
  }, _vm._l(_vm.sourceTypeArray, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`addTvuOne.${item.label}`),
        "value": item.value
      }
    });
  }), 1), _c('el-divider', {
    staticClass: "searchDivider",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-input', {
    ref: "drawInput",
    attrs: {
      "placeholder": _vm.$t('addTvuOne.placeholder')
    },
    on: {
      "input": _vm.searchSourceList
    },
    model: {
      value: _vm.sourceListParams.condition,
      callback: function ($$v) {
        _vm.$set(_vm.sourceListParams, "condition", $$v);
      },
      expression: "sourceListParams.condition"
    }
  })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t(`addTvuOne.${_vm.titleMap[_vm.selectDeviceType]}`)))])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectDevicePeerId && _vm.selectDeviceType != 'producer' && _vm.selectDeviceType != 'channel',
      expression: "selectDevicePeerId && selectDeviceType != 'producer' && selectDeviceType != 'channel'"
    }],
    staticClass: "receiverTips"
  }, [_vm._v(_vm._s(_vm.$t('common.receiverTips')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.selectDevicePeerId && _vm.showTitle && !_vm.hasClickNext,
      expression: "!selectDevicePeerId && showTitle && !hasClickNext"
    }],
    staticClass: "middleBox between"
  }, [_c('el-select', {
    staticClass: "packReceiverSelect",
    attrs: {
      "popper-class": "packReceiverSelect"
    },
    on: {
      "change": _vm.changeSelectType
    },
    model: {
      value: _vm.selectDeviceType,
      callback: function ($$v) {
        _vm.selectDeviceType = $$v;
      },
      expression: "selectDeviceType"
    }
  }, _vm._l(_vm.sourceTypeArray, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`addTvuOne.${item.label}`),
        "value": item.value
      }
    });
  }), 1), _c('el-select', {
    staticClass: "packStatusSelect",
    attrs: {
      "placeholder": _vm.$t('addTvuOne.packStatus'),
      "popper-class": "packReceiverSelect"
    },
    on: {
      "change": _vm.getSourceListByFilter
    },
    model: {
      value: _vm.packStatus,
      callback: function ($$v) {
        _vm.packStatus = $$v;
      },
      expression: "packStatus"
    }
  }, _vm._l(_vm.packStatusArray[_vm.selectDeviceType], function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`addTvuOne.${item.label}`),
        "value": item.value
      }
    });
  }), 1)], 1), !_vm.selectDevicePeerId && !_vm.hasClickNext ? _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scrollS,
      expression: "scrollS"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingS,
      expression: "loadingS"
    }],
    staticClass: "content scrollbar",
    class: {
      receiverBox: _vm.selectDeviceType != 'pack'
    }
  }, [_vm._l(_vm.sourceList, function (item, index) {
    var _item$partyCodes;
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('div', {
      staticClass: "listLeft"
    }, [_c('span', {
      staticClass: "redCircle",
      class: {
        visiable: item.status == 2
      }
    }), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.showDeviceId(item),
        "placement": "top"
      }
    }, [_c('span', {
      class: {
        grayColor: _vm.needShowGrayClass(item)
      }
    }, [_vm._v(_vm._s(item.name || item.sourceName || item.channelName))])]), item.supportedBuild == -1 ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('addTvuOne.TestedDevices'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-help2"
    })]) : _vm._e()], 1), _c('div', {
      staticClass: "listRight"
    }, [_vm.selectDeviceType === 'pack' && (_item$partyCodes = item.partyCodes) !== null && _item$partyCodes !== void 0 && _item$partyCodes.length ? _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": _vm.showTips(item)
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]) : _vm._e(), _vm.selectDeviceType === 'producer' || _vm.selectDeviceType === 'channel' ? _c('el-radio', {
      staticClass: "right radioBox",
      attrs: {
        "label": item.peerId || item.receiverId || item.pid
      },
      on: {
        "input": function ($event) {
          return _vm.saveSelectDeviceInfo(item);
        }
      },
      model: {
        value: _vm.selectDevicePeerId,
        callback: function ($$v) {
          _vm.selectDevicePeerId = $$v;
        },
        expression: "selectDevicePeerId"
      }
    }) : _vm._e(), _vm.showNoTipsCheckBox(item) ? _c('el-checkbox', {
      staticClass: "right",
      model: {
        value: item.hadSelected,
        callback: function ($$v) {
          _vm.$set(item, "hadSelected", $$v);
        },
        expression: "item.hadSelected"
      }
    }) : _vm._e(), _vm.showTipsCheckBox(item) ? _c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('el-checkbox', {
      staticClass: "right",
      attrs: {
        "disabled": _vm.returnCheckBoxDisabled(item)
      },
      model: {
        value: item.hadSelected,
        callback: function ($$v) {
          _vm.$set(item, "hadSelected", $$v);
        },
        expression: "item.hadSelected"
      }
    }), _c('span', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('p', [_vm._v(_vm._s(_vm.showDeviceTips(item)))])])], 1) : _vm._e()], 1)]);
  }), _vm.sourceList.length <= 0 && !_vm.loadingS ? _c('div', {
    staticClass: "noReTips"
  }, [_c('span', [_vm._v(_vm._s(_vm.returnDefaultText))]), _vm.sourceListParams.condition ? _c('span', [_vm._v(_vm._s(_vm.$t('remainWords.for')) + " \"" + _vm._s(_vm.sourceListParams.condition) + "\" " + _vm._s(_vm.$t('remainWords.underAccount')))]) : _vm._e()]) : _vm._e()], 2) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingS,
      expression: "loadingS"
    }],
    staticClass: "receiverSetBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.videoInput')))]), _c('el-radio-group', {
    staticClass: "videoGroup",
    on: {
      "input": _vm.dealDefaultValue
    },
    model: {
      value: _vm.selectSourceType,
      callback: function ($$v) {
        _vm.selectSourceType = $$v;
      },
      expression: "selectSourceType"
    }
  }, [_vm.selectDeviceInfo.status == 3 ? _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('common.noVailiableInput')
    }
  }, [_c('el-radio', {
    staticClass: "radioBox showLabel",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("SDI IN/HDMI IN")])], 1) : _vm._e(), _vm._l(_vm.receiverSourceType, function (item) {
    return _c('el-radio', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !(_vm.selectDeviceType == 'pack' && _vm.selectDeviceInfo.status == 3 && item == 'SDIIN' || _vm.selectDeviceType == 'pack' && item == 'noVideo' && _vm.notSupportVoIP),
        expression: "!((selectDeviceType == 'pack' && selectDeviceInfo.status == 3 && item == 'SDIIN') || (selectDeviceType == 'pack' && item == 'noVideo' && notSupportVoIP))"
      }],
      key: item,
      staticClass: "radioBox showLabel",
      class: {
        isProducer: _vm.selectDeviceType === 'producer'
      },
      attrs: {
        "label": item,
        "disabled": _vm.videoRadioDisabled(item)
      }
    }, [_vm._v(" " + _vm._s(_vm.returnLabel(item)) + " ")]);
  }), _vm.notSupportVoIP ? _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.notSupportVoIPTips
    }
  }, [_c('el-radio', {
    staticClass: "radioBox showLabel",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("No Video")])], 1) : _vm._e()], 2), _c('el-divider', {
    staticClass: "receiverDivider"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.audioInput')))]), _c('el-radio-group', {
    model: {
      value: _vm.selectAudioChannel,
      callback: function ($$v) {
        _vm.selectAudioChannel = $$v;
      },
      expression: "selectAudioChannel"
    }
  }, [_vm._l(_vm.receiverAudioChannel[_vm.selectSourceType], function (item) {
    return _c('el-radio', {
      key: item,
      staticClass: "radioBox showLabel",
      attrs: {
        "label": item,
        "disabled": _vm.audioRadioDisabled(item)
      }
    }, [_vm._v(" " + _vm._s(_vm.returnAudioInput(item)) + " ")]);
  }), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectDeviceType === 'pack' || _vm.selectDeviceType === 'receiver',
      expression: "selectDeviceType === 'pack' || selectDeviceType === 'receiver'"
    }],
    key: "voip",
    staticClass: "radioBox showLabel oneLine",
    attrs: {
      "label": "voip",
      "disabled": _vm.audioRadioDisabled('voip')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.voip')) + " "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.selectDeviceType === 'pack' ? _c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.packVoIPTip')))]) : _vm._e(), _vm.selectDeviceType === 'receiver' ? _c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.receiverVoIPTip')))]) : _vm._e(), _vm.selectDeviceType === 'receiver' ? _c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.receiverVoIPTip1')))]) : _vm._e(), _vm.selectDeviceType === 'receiver' ? _c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.recevierVersion')))]) : _vm._e()])])], 1), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectDeviceType === 'pack' || _vm.selectDeviceType === 'receiver',
      expression: "selectDeviceType === 'pack' || selectDeviceType === 'receiver'"
    }],
    key: "noAudio",
    staticClass: "radioBox showLabel oneLine",
    attrs: {
      "label": "noAudio",
      "disabled": _vm.audioRadioDisabled('noAudio')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.noAudio')) + " ")])], 2), _vm.selectDeviceType === 'receiver' ? _c('div', {
    staticClass: "duckAudioContent"
  }, [_c('el-divider', {
    staticClass: "receiverDivider"
  }), _c('el-checkbox', {
    attrs: {
      "disabled": _vm.selectSourceType != 'noVideo'
    },
    model: {
      value: _vm.autoDuck,
      callback: function ($$v) {
        _vm.autoDuck = $$v;
      },
      expression: "autoDuck"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.autoDuck')) + " "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  }), _c('div', {
    staticStyle: {
      "width": "361px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.autoDuckTitle')))])])])], 1), _vm.autoDuck ? _c('div', [_c('el-radio-group', {
    staticClass: "vocalGroup",
    on: {
      "input": _vm.selectVocalTract
    },
    model: {
      value: _vm.vocalTract,
      callback: function ($$v) {
        _vm.vocalTract = $$v;
      },
      expression: "vocalTract"
    }
  }, _vm._l(_vm.vocalTractType, function (item) {
    return _c('el-radio', {
      key: item,
      staticClass: "radioBox showLabel",
      attrs: {
        "label": item
      }
    });
  }), 1), _c('div', {
    staticClass: "volume"
  }, [_c('div', {
    staticClass: "volumeTitle"
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.duckLevel')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.changeVolumeInputValue
    },
    model: {
      value: _vm.duckVolume,
      callback: function ($$v) {
        _vm.duckVolume = $$v;
      },
      expression: "duckVolume"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeVolume,
      "input": function ($event) {
        _vm.duckVolume = Number(_vm.duckVolume);
      }
    },
    model: {
      value: _vm.inputVolume,
      callback: function ($$v) {
        _vm.inputVolume = $$v;
      },
      expression: "inputVolume"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("%")])], 1)], 1) : _vm._e(), _vm.selectDeviceType === 'receiver' ? _c('el-checkbox', {
    staticStyle: {
      "margin-top": "8px",
      "font-weight": "normal"
    },
    model: {
      value: _vm.vbrVal,
      callback: function ($$v) {
        _vm.vbrVal = $$v;
      },
      expression: "vbrVal"
    }
  }, [_vm._v(" VBR ")]) : _vm._e()], 1) : _vm._e()], 1), _c('div', {
    staticClass: "versionWords"
  }, [_vm.selectDeviceType === 'pack' ? _c('div', {
    staticClass: "packTips"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('remainWords.tvuoneVersions')))]), _vm._v(" " + _vm._s(_vm.$t('remainWords.tvuoneVersionsOne')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.packHwNames) + " ")]) : _vm._e(), _vm.selectDeviceType === 'receiver' ? _c('div', {
    staticClass: "receiverTips"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.versionText')))])]) : _vm._e()]), _vm.returnShowFoot ? _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "footLeft"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left pointer",
    on: {
      "click": function ($event) {
        return _vm.gobackLastOperation();
      }
    }
  }), _vm.selectDeviceType === 'receiver' || _vm.selectDeviceType === 'pack' ? _c('span', {
    staticClass: "selectNumber"
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.hasSelectedNumber', {
    number: _vm.hasSelectedNumber
  })))]) : _vm._e()]), _c('div', {
    staticClass: "footRight"
  }, [(_vm.selectDeviceType === 'receiver' || _vm.selectDeviceType === 'pack') && !_vm.hasClickNext ? _c('span', {
    staticClass: "pointer right",
    on: {
      "click": _vm.clickNext
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.next')) + " ")]) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.returnShowAddBtn,
      expression: "returnShowAddBtn"
    }],
    staticClass: "pointer right",
    on: {
      "click": function ($event) {
        return _vm.saveOperation('add');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.returnSaveOrAddBtnText) + " ")]), _vm.$route.name != 'intercom' && _vm.userInfo.channelMode == 0 && _vm.selectDeviceType === 'pack' && _vm.packStatus != 'recover' && _vm.sourceList.some(item => item.hadSelected === true) && _vm.hasClickNext ? _c('span', {
    staticClass: "right autoAdd",
    class: {
      disabled: _vm.selectAudioChannel === 'voip'
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "popper-class": "recoverTips"
    }
  }, [_vm.packStatus !== 'recover' ? _c('i', {
    staticClass: "iconfont icon-help2 right"
  }) : _vm._e(), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticClass: "tipsText"
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.autoRecoverTips')))])])]), _c('span', {
    staticClass: "pointer right autoAddBtn",
    on: {
      "click": function ($event) {
        return _vm.saveOperation('autoAdd');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.adds')) + " "), _c('span', {
    staticClass: "autoRecoverText"
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.autoRecover')))])])], 1) : _vm._e(), _c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_vm.packStatus == 'recover' ? _c('i', {
    staticClass: "iconfont icon-help2 right"
  }) : _vm._e(), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('addTvuOne.removeTips')))])])]), _vm.packStatus == 'recover' ? _c('span', {
    staticClass: "right removeBtn",
    on: {
      "click": _vm.cancelAutoRecover
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.remove')))]) : _vm._e()], 1)]) : _vm._e(), _c('tipsDailog', {
    attrs: {
      "info": _vm.receiverInfo
    },
    on: {
      "cancel": _vm.cancelAdd,
      "save": _vm.sendReceiverJoinParty
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.receiverPopText')))])]), _c('tipsDailog', {
    staticClass: "switchTvuOne",
    attrs: {
      "info": _vm.switchInfo
    },
    on: {
      "cancel": _vm.cancelSwitch,
      "save": _vm.switchPackJoinParty
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('addTvuOne.theTvuOne')))]), _c('span', [_vm._v(" " + _vm._s(_vm.switchPackTips))]), _c('div', [_vm._v(_vm._s(_vm.$t('addTvuOne.confirmSwitch')))])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };